<template>
  <div class="margin-top-xxs">
    <div role="progressbar" :aria-label="ariaLabel">
      <ProgressBar :value="progressBarValue" :show-value="false" aria-hidden="true" />
    </div>
    <div class="grid-x align-justify margin-top-xxs">
      <div v-for="status in progressBarData" :key="status.shipmentLabel" class="medium text-left">
        {{ status.shipmentLabel }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ProgressBar from '@nuxt-common/atomic-ui/app/components/progressBar/ProgressBar';

const props = defineProps({
  progressBarData: {
    type: Array,
    default: () => [],
  },
  progressBarValue: {
    type: Number,
    default: 0,
  },
});

const ariaLabel = computed(() => props.progressBarData.find((el) => el.statusBarValue === +props.progressBarValue)?.shipmentLabel);
</script>
